module.exports = __webpack_public_path__ + "static/media/photo-16.90ac7798.avif";